import React from 'react';
import {View, SafeAreaView, Pressable} from 'react-native';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../theme';
import Button from '../../components/elements/Button';
import Text from '../../components/elements/Text';
import {BUTTON_TYPES} from '../../utils/Constants';
import Input from '../../components/elements/Input';
import Divider from '../../components/elements/Divider';
import Popup from '../../components/elements/Popup';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';
import {LeftArrowIcon} from '../../utils/SvgIcons';

const UI = ({
  navigation,
  setInputError,
  setInputId,
  inputError,
  checkAttempts,
  inputId,
  setModalVisible,
  modalVisible,
  checkEmployerId,
  hasrequestUniqueIdFeatureEnabled,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const navigateToLogin = () => navigation('/login', {replace: true});

  const navigateToRequestUniqueId = () => {
    navigation('/request-unique-id', {state: {prevPath: '/sign-up'}});
  };

  return (
    <SafeAreaView
      testID={tID('SubmitEmployerId-SafeAreaView-Main')}
      style={styles.mainView}>
      <Pressable
        testID={tID('SubmitEmployerId-Pressable-SigninRouteLink')}
        style={styles.backPressable}
        onPress={navigateToLogin}>
        <LeftArrowIcon tintColor={colors.link} />
        <Text
          testID={tID('SubmitEmployerId-Text-SigninRoute')}
          variation="Text1SemiBold"
          color={colors.link}
          lineHeight={21}
          style={CommonStyles.ml_12}>
          Back to Sign-In
        </Text>
      </Pressable>
      <Text
        testID={tID('SubmitEmployerId-Text-Title')}
        variation="HeadlineBold28"
        color={colors.textPrimary}
        style={CommonStyles.mb_12}>
        Submit your Unique ID
      </Text>
      <Text
        testID={tID('SubmitEmployerId-Text-SubTitle')}
        variation="Body1Regular"
        color={colors.textSecondary}
        style={CommonStyles.mb_22}>
        Provide your employer’s unique ID below to begin creating your account.
      </Text>
      <Divider />
      <Input
        testID={tID('SubmitEmployerId-Input-EmployerUniqueId')}
        inputTitle={'Employer’s Unique ID'}
        placeholder={'Type here...'}
        errorText={'Incorrect or not found code.'}
        onChangeText={newText => {
          setInputError(false);
          setInputId(newText);
        }}
        hasError={inputError}
        containerStyle={styles.input}
      />
      {hasrequestUniqueIdFeatureEnabled && (
        <Text
          testID={tID('SubmitEmployerId-Text-NoEmployerUniqueId')}
          variation="Subtitle2Regular"
          color={colors.textPrimary}
          style={CommonStyles.mt_32}>
          Don’t have an Employer's Unique ID?{' '}
          <Text
            testID={tID('SubmitEmployerId-Text-RequestAccess')}
            onPress={navigateToRequestUniqueId}
            variation="Body2"
            color={colors.link}
            lineHeight={21}
            style={CommonStyles.underlined_text}>
            Request Access Now
          </Text>
        </Text>
      )}
      <View style={[CommonStyles.mt_22, CommonStyles.mb_32]}>
        <Divider />
      </View>
      <Button
        testID={tID('SubmitEmployerId-Button-Continue')}
        onPress={() => checkAttempts(checkEmployerId)}
        title={'Continue'}
        buttonType={BUTTON_TYPES.Filled}
        titleColor={colors.textOnAccent}
        disabled={inputId === ''}
        style={CommonStyles.max_width_292}
      />

      <Text
        testID={tID('SubmitEmployerId-Text-AlreadyUser')}
        variation="Subtitle2Regular"
        color={colors.textPrimary}
        style={CommonStyles.mt_32}>
        Already have an account?{' '}
        <Text
          testID={tID('SubmitEmployerId-Text-SignIn')}
          variation="Body2"
          color={colors.link}
          lineHeight={21}
          style={CommonStyles.underlined_text}
          onPress={navigateToLogin}>
          Sign In
        </Text>
      </Text>
      <Popup
        testID={tID('SubmitEmployerId-Modal-Popup')}
        visible={modalVisible}
        title="Request Access"
        onRequestClose={() => {
          setModalVisible(!modalVisible);
        }}
        description={
          <>
            Looks like we're having trouble validating your ID. Tap '
            <Text
              testID={tID('SubmitEmployerId-Text-RequestNow')}
              variation="Body1SemiBold"
              color={colors.textMuted}
              style={CommonStyles.mb_12}>
              Request Now
            </Text>
            ' to request access from a Diathrive Admin.
          </>
        }>
        <Button
          testID={tID('SubmitEmployerId-Button-Close')}
          style={CommonStyles.full_flex}
          title={'Close'}
          onPress={() => setModalVisible(!modalVisible)}
        />
        <Button
          testID={tID('SubmitEmployerId-Button-RequestNow')}
          style={styles.requestNowButton}
          onPress={() => {
            setModalVisible(!modalVisible); //also possibly close the app
            navigateToRequestUniqueId();
          }}
          title={'Request Now'}
          buttonType={BUTTON_TYPES.Filled}
          titleColor={colors.textOnAccent}
        />
      </Popup>
    </SafeAreaView>
  );
};

export default UI;
